import { createFileRoute, Outlet, useNavigate } from "@tanstack/react-router";
import { Database } from "lucide-react";
import { useGetMyFeatures } from "@tubo/api-models/hooks/tenant-feature-api.hooks";
import { Button } from "@tubo/ui/components/ui/button";

export const Route = createFileRoute("/_app/semantic-platform/data-assets")({
  component: DataAssetsLayout,
});

/**
 * 数据资产路由级 Feature 门禁(波次4 4A-5)
 * 未开启 semanticData.assetPublishing 的租户:入口隐藏 + 直接 URL 被拦截。
 */
function DataAssetsLayout() {
  const navigate = useNavigate();
  const { data: features, isLoading } = useGetMyFeatures({ query: {} });

  if (isLoading) {
    return <div className="flex h-full items-center justify-center text-muted-foreground">加载中…</div>;
  }

  if (!features?.assetPublishing) {
    return (
      <div className="flex h-full items-center justify-center text-muted-foreground">
        <div className="text-center">
          <Database className="mx-auto mb-3 h-12 w-12 text-icon-secondary-muted" />
          <p className="text-sm font-medium">数据资产</p>
          <p className="mt-1 text-xs text-muted-foreground/70">该功能尚未对当前租户开放</p>
          {/* 直链进入时浏览器历史可能是空/站外，返回固定落知识本体域首页 */}
          <Button variant="outline" size="sm" className="mt-4" onClick={() => navigate({ to: "/semantic-platform" })}>
            返回
          </Button>
        </div>
      </div>
    );
  }

  return <Outlet />;
}
